module.exports = __webpack_public_path__ + "25d206be08ee780af8bd9559935c0892.MP3";